














































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";
import { calculateEwss, getEwssAlertType, getEwssRekomendasi } from "@/utils/ewss";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";

@Component({
  components: { VCDateTimePicker }
})
export default class MonitoringTransfusiTtvDialog extends Vue {
  @Prop() value!: boolean;
  @Prop() monitoringId!: number;
  @Prop({ default: null }) editItem!: any;
  @Prop({ default: "intra" }) suggestedFase!: string;
  @Prop({ default: null }) seedWaktu!: string | null;

  saving = false;
  form: any = {};

  faseOptions = [
    { text: "Pre Transfusi", value: "pre" },
    { text: "Intra Transfusi", value: "intra" },
    { text: "Post Transfusi", value: "post" },
  ];

  get show() { return this.value; }
  set show(val: boolean) { this.$emit("input", val); }

  get isEdit() { return !!this.editItem; }

  get waktuPengukuranDate(): Date | null {
    return composeDate(
      this.form.waktu_pengukuran,
      (this.form.waktu_pengukuran || "").slice(11, 16)
    );
  }
  set waktuPengukuranDate(val: Date | null) {
    this.$set(
      this.form,
      "waktu_pengukuran",
      val ? `${toDateString(val)} ${toTimeString(val)}:00` : null
    );
  }

  get ewssPreview() {
    if (!this.form.respirasi || !this.form.spo2 || !this.form.tekanan_darah_sistolik || !this.form.nadi || !this.form.suhu) {
      return null;
    }
    return calculateEwss({
      respirasi: this.form.respirasi,
      spo2: this.form.spo2,
      hasO2Support: false,
      tdSistolik: this.form.tekanan_darah_sistolik,
      nadi: this.form.nadi,
      kesadaran: "A",
      suhu: this.form.suhu,
    });
  }

  get ewssAlertType() {
    return getEwssAlertType(this.ewssPreview ? this.ewssPreview.kategori : null);
  }

  get ewssRekomendasi() {
    return this.ewssPreview ? getEwssRekomendasi(this.ewssPreview.kategori) : "";
  }

  @Watch("value")
  onOpen(val: boolean) {
    if (val) {
      if (this.editItem) {
        this.form = { ...this.editItem };
        if (this.form.waktu_pengukuran) {
          this.form.waktu_pengukuran = moment(this.form.waktu_pengukuran).format("YYYY-MM-DD HH:mm:ss");
        }
      } else {
        this.resetForm();
      }
    }
  }

  resetForm() {
    this.form = {
      fase: this.suggestedFase,
      waktu_pengukuran: moment(this.seedWaktu || undefined).format("YYYY-MM-DD HH:mm:ss"),
      tekanan_darah_sistolik: null,
      tekanan_darah_diastolik: null,
      nadi: null,
      respirasi: null,
      suhu: null,
      spo2: null,
      keluhan: "",
      keterangan: "",
    };
  }

  close() {
    this.show = false;
    this.form = {};
  }

  async simpan() {
    this.saving = true;
    try {
      let resp;
      if (this.isEdit) {
        resp = await MonitoringTransfusiSvc.updateTtv(this.monitoringId, this.editItem.id, this.form);
      } else {
        resp = await MonitoringTransfusiSvc.addTtv(this.monitoringId, this.form);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(this.isEdit ? "TTV diperbarui" : "TTV ditambahkan");

        // Show clinical alerts from API
        if (resp.data.alerts && resp.data.alerts.length > 0) {
          setTimeout(() => {
            alert("ALERT KLINIS:\n" + resp.data.alerts.join("\n"));
          }, 500);
        }

        this.close();
        this.$nextTick(() => {
          this.$emit("saved");
        });
      }
    } catch {
      // handled
    }
    this.saving = false;
  }
}
